import { render, staticRenderFns } from "./AdminElements.vue?vue&type=template&id=4ab03023&scoped=true"
import script from "./AdminElements.vue?vue&type=script&lang=js"
export * from "./AdminElements.vue?vue&type=script&lang=js"
import style0 from "./AdminElements.vue?vue&type=style&index=0&id=4ab03023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab03023",
  null
  
)

export default component.exports